import React from 'react';

interface UploadMediaProps {
  media: string[];
}

export const UploadMedia: React.FC<UploadMediaProps> = ({ media }) => {
  if (!media || media.length === 0) return null;
  return (
    <div className="w-full min-w-screen flex flex-wrap gap-2 px-0 py-2 overflow-x-auto">
      {media.map((url, idx) => (
        <img
          key={idx}
          src={url}
          alt={`uploaded-media-${idx}`}
          className="w-full max-w-full h-48 object-cover rounded-[6px] border border-[#E7E7E6]"
        />
      ))}
    </div>
  );
};

export default UploadMedia; 